export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 1.b9d7bd4f.jpg";